import React, { useMemo } from 'react';
import { alpha, useTheme } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { IconClipboardList } from '@tabler/icons-react';
import { revealOnboardingChecklist, useOnboardingChecklist } from 'hooks/useOnboardingChecklist';
import { ONBOARDING_STEPS } from 'utils/onboarding-checklist-constants';

/**
 * חיווי בבר העליון כשההתקדמות < 100% **וגם** האשף לא פתוח במלואו:
 * ממוזע (Fab) או סגור לחלוטין (X). כשהפאנל מורחב — אין כפל.
 */
const OnboardingSetupHeaderCue: React.FC = () => {
  const theme = useTheme();
  const { state, pendingCount, setCollapsed } = useOnboardingChecklist();

  const total = ONBOARDING_STEPS.length;
  const progressPercent = useMemo(
    () => Math.round(((total - pendingCount) / total) * 100),
    [pendingCount, total],
  );

  const fullPanelOpen = !state.dismissed && !state.collapsed;
  if (progressPercent >= 100 || fullPanelOpen) {
    return null;
  }

  const sec = theme.palette.secondary;

  return (
    <Tooltip title="לחצו לפתיחת אשף ההתקנה">
      <Button
        size="small"
        variant="outlined"
        color="secondary"
        onClick={() => (state.dismissed ? revealOnboardingChecklist() : setCollapsed(false))}
        aria-label={`אשף התקנה — ${progressPercent} אחוז; פתח`}
        startIcon={<IconClipboardList size={18} stroke={1.5} aria-hidden />}
        sx={{
          minWidth: 0,
          maxWidth: { xs: 200, sm: 260 },
          textTransform: 'none',
          fontWeight: 700,
          px: 1.25,
          py: 0.35,
          borderColor: alpha(sec.main, 0.5),
          bgcolor: alpha(sec.main, 0.08),
          transition: theme.transitions.create(['background-color', 'border-color', 'box-shadow'], {
            duration: theme.transitions.duration.shorter,
          }),
          '&:hover': {
            borderColor: sec.main,
            bgcolor: alpha(sec.main, 0.14),
            boxShadow: `0 0 0 1px ${alpha(sec.main, 0.3)}`,
          },
        }}
      >
        {progressPercent}%
      </Button>
    </Tooltip>
  );
};

export default OnboardingSetupHeaderCue;
